import {componentLoader, componentConfig} from "../../lib/component_initializer";
import {Promocode} from "./promocode"

export const promocodeLoader = function (options = {}) {
    componentLoader(componentConfig(Promocode, Promocode.config.componentTypeKey, Promocode.config.baseHtmlClass), options);
};

